import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "@quest/i18n/en.json";
import nl from "@quest/i18n/nl.json";

i18n.use(initReactI18next).init({
  resources: {
    en: { ...en },
    nl: { ...nl },
  },
  lng: localStorage.getItem("locale") || "nl",
  fallbackLng: "nl",
  supportedLngs: ["en", "nl"],
  nonExplicitSupportedLngs: true,
  load: "languageOnly",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;

